// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3MgIy","toggleWrap":"styles_toggleWrap__2YCOt","content":"styles_content__2rH68","selectAreaCode":"styles_selectAreaCode__3jJN3"};